import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import MembershipsNavigation from '../MembershipsNavigation';
import HeaderLayout from '../../../../../components/HeaderLayout';
import { getCheckoutCartTotalItems } from '../../../../../../../services/checkout/redux/checkoutSelectors';
import { openModal as openModalAction } from '../../../../../../../actions/modal-actions';
import { CHECKOUT_CART_MODAL } from '../../../../../../../services/checkout/components/CheckoutCart/modal';
import CartToggle from '../../../../../../../services/checkout/components/CartToggle/CartToggle';
import HomeIcon from '../../../../../../../components/icons/HomeIcon';
import Button from '../../../../../../../components/global/Button';
import LogoPoweredBy from '../../../../../../../components/global/LogoPoweredBy';
import { getAsset } from '../../../../../../../util/assets';
import {
  getAlbumMembershipGroupEntityAccount,
  isPictureDayMembership,
} from '../../helpers';
import useOpenAlert from '../../../../../../../hooks/useOpenAlert';
import HelpBubblesIcon from '../../../../../../../components/icons/HelpBubblesIcon';

const propTypes = {
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  totalCartItems: PropTypes.number,
  openModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const Header = ({
  albumMembershipGroup,
  totalCartItems,
  openModal,
  history,
}) => {
  const openAlert = useOpenAlert();
  const cartToggleRef = useRef();
  const isPictureDay = isPictureDayMembership(albumMembershipGroup);
  const creator = getAlbumMembershipGroupEntityAccount(albumMembershipGroup);
  const displayName = albumMembershipGroup?.display_name;
  const emailSubject = displayName
    ? `Question regarding photos from ${displayName}`
    : '';

  const contactEmailAddress =
    creator?.pro_settings?.photo_attribution_page?.email_address ??
    creator?.email_address;

  return (
    <Fragment>
      <HeaderLayout
        className="album-membership-group-header"
        leftSlot={
          <Fragment>
            <img
              alt=""
              src={getAsset('/waldo-icon.svg')}
              className="header-logo d-md-none"
            />
            <LogoPoweredBy className="d-none d-md-flex" />
          </Fragment>
        }
        titleSlot={<MembershipsNavigation />}
        rightSlot={
          <Fragment>
            {(totalCartItems ?? 0) > 0 && (
              <CartToggle
                total={totalCartItems}
                popInView
                ref={cartToggleRef}
                onClick={() => openModal(CHECKOUT_CART_MODAL)}
              />
            )}
            {!isPictureDay && (
              <Button
                pill
                btnOutline
                btnSize="sm"
                onClick={() => history.push(`/app/shutterbug/folders`)}
                className="btn-home"
              >
                <HomeIcon size={24} className="d-md-none" color="#0d84fe" />
                <HomeIcon className="d-none d-md-block mr-1" color="#0d84fe" />
                <span className="d-none d-md-inline-block">
                  Back to home
                </span>{' '}
              </Button>
            )}
            {isPictureDay && contactEmailAddress && (
              <Button
                btnStyle="link"
                onClick={() =>
                  openAlert({
                    type: 'info',
                    message: (
                      <div className="text-center">
                        <img
                          src={
                            creator?.logo_image?.url ??
                            getAsset('/waldo-icon.svg')
                          }
                          alt={creator?.organization_name}
                          width="48"
                          className="mb-2"
                        />
                        <p>
                          Have a question? Email us at:
                          <br />
                          <a
                            href={`mailto:${contactEmailAddress}?subject=${emailSubject}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contactEmailAddress}
                          </a>
                        </p>
                      </div>
                    ),
                  })
                }
              >
                <HelpBubblesIcon
                  id="consumer-matches-help-bubbles"
                  size={24}
                  color="#0d84fe"
                />
              </Button>
            )}
          </Fragment>
        }
      />
    </Fragment>
  );
};

Header.propTypes = propTypes;

export { Header as HeaderComponent };

const mapStateToProps = state => ({
  totalCartItems: getCheckoutCartTotalItems(state),
});

const mapDispatchToProps = {
  openModal: openModalAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(Header);
